import KeyIcon from '@assets/svgs/key.svg';
import { PageHead } from '@components/PageHead';
import './index.css';
import { useState } from 'react';
import { useMutation } from '@apollo/client';
import { UPDATE_PASSWORD_FORGOT_BY_EMAIL } from '@gql/auth';
import { useNavigate } from 'react-router-dom';
import { TextField, Box, Typography, InputLabel } from '@mui/material';
import { useSnackbar } from '@components/Snackbar/SnackbarProvider';

export const ForgotPasswordPage = () => {
    const [email, setEmail] = useState('');
    const navigate = useNavigate();
    const { showSnackbar } = useSnackbar();

    const [updatePasswordForgotByEmail, { loading }] = useMutation(UPDATE_PASSWORD_FORGOT_BY_EMAIL, {
        onCompleted: (data) => {
            // Afficher le message de succès
            showSnackbar(
                data?.updatePasswordForgotByEmail?.message || 'Code de réinitialisation envoyé avec succès ! Vérifiez votre e-mail.',
                'success'
            );
            // Naviguer vers la page de réinitialisation avec l'email pré-rempli
            navigate(`/reset-password?email=${encodeURIComponent(email.trim().toLowerCase())}`);
        },
        onError: (error) => {
            console.error('Erreur lors de l\'envoi de l\'e-mail de réinitialisation :', error);
            showSnackbar(
                error.message || 'Échec de l\'envoi de l\'e-mail de réinitialisation. Veuillez réessayer.',
                'error'
            );
        },
    });

    const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(e.target.value);
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!email.trim()) {
            showSnackbar('Veuillez entrer votre adresse e-mail', 'warning');
            return;
        }

        try {
            await updatePasswordForgotByEmail({
                variables: { email: email.trim().toLowerCase() },
            });
        } catch (err) {
            return;
        }
    };

    return (
        <>
            <PageHead useDynamicTitle />
            <Box className="forgot-password-container">
                {/* Icône de clé avec lueur violette */}
                <Box className="key-icon-wrapper">
                    <i className='fi fi-br-key' style={{ fontSize: '24px' }}></i>
                </Box>

                {/* Titre et sous-titre */}
                <Box className="header-section">
                    <Typography variant="h1" className="main-heading">
                        Réinitialisez votre mot de passe
                    </Typography>
                    <Typography variant="body1" className="subtitle">
                        Pour réinitialiser votre mot de passe, veuillez saisir l'adresse e-mail de votre compte Upercut.
                    </Typography>
                </Box>

                {/* Formulaire */}
                <form className="forgot-form" onSubmit={handleSubmit}>
                    {/* Champ email */}
                    <Box className="input-group">
                        <InputLabel className="input-label">
                            E-mail<span className="required-asterisk">*</span>
                        </InputLabel>
                        <TextField
                            value={email}
                            onChange={handleEmailChange}
                            placeholder="Ex : votreadresse@mail.com"
                            disabled={loading}
                            fullWidth
                            className="custom-input"
                            variant="outlined"
                            type="email"
                        />
                    </Box>

                    {/* Bouton de soumission */}
                    <button
                        type="submit"
                        disabled={!email.length || loading}
                        className="submit-button"
                    >
                        {loading ? 'Envoi en cours...' : 'Réinitialiser le mot de passe'}
                    </button>
                </form>

                {/* Avis de sécurité */}
                <Typography variant="body2" className="security-notice">
                    Pour des raisons de sécurité, nous ne stockons PAS votre mot de passe. Soyez assuré que nous ne vous enverrons jamais votre mot de passe par e-mail. Pour plus d'informations, vous pouvez nous contacter à{' '}
                    <a href="mailto:support@upercut.fr" className="support-link">
                        support@upercut.fr
                    </a>
                    .
                </Typography>
            </Box>
        </>
    );
};

